export default {"src":"https://cdn.seaya.az/dist//_next/static/media/overlay_1.317c93a1.svg","height":1024,"width":1440,"blurWidth":0,"blurHeight":0};